mutation UpdateTargetAudience(
  $targetAudienceId: ID!
  $targetAudienceInput: TargetAudienceInput!
) {
  updateTargetAudience(
    input: {
      targetAudienceId: $targetAudienceId
      targetAudienceInput: $targetAudienceInput
    }
  ) {
    targetAudience {
      id
    }
  }
}
